export default __webpack_public_path__ + "static/media/spotify.bb7be5d8.svg";